import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export function createAppRouter(adminPath = '/admin') {
  const normalizedAdminPath = `/${adminPath.replace(/^\/+|\/+$/g, '') || 'admin'}`;
  const router = createRouter({
    history: createWebHistory(),
    scrollBehavior: () => ({ top: 0, behavior: 'smooth' }),
    routes: [
    { path: '/', name: 'home', component: () => import('@/views/PublicHome.vue') },
    { path: '/search', name: 'public-search', component: () => import('@/views/PublicSearch.vue') },
    { path: '/api-docs', name: 'api-docs', component: () => import('@/views/PublicApiDocs.vue') },
    { path: '/category/:slug', name: 'public-category', component: () => import('@/views/PublicCategory.vue') },
    { path: `${normalizedAdminPath}/login`, name: 'login', component: () => import('@/views/AdminLogin.vue'), meta: { guest: true } },
    {
      path: normalizedAdminPath, component: () => import('@/layouts/AdminLayout.vue'), meta: { auth: true },
      children: [
        { path: '', redirect: { name: 'dashboard' } },
        { path: 'dashboard', name: 'dashboard', component: () => import('@/views/AdminDashboard.vue'), meta: { title: '工作台' } },
        { path: 'accounts', name: 'accounts', component: () => import('@/views/AccountsView.vue'), meta: { title: '账号列表' } },
        { path: 'transfers', name: 'transfers', component: () => import('@/views/TransferView.vue'), meta: { title: '转存分享' } },
        { path: 'transfer-jobs', name: 'transfer-jobs', component: () => import('@/views/TransferJobsView.vue'), meta: { title: '转存任务' } },
        { path: 'collectors', name: 'collectors', component: () => import('@/views/CollectorView.vue'), meta: { title: '短剧采集' } },
        { path: 'resources', name: 'resources', component: () => import('@/views/ResourcesView.vue'), meta: { title: '资源列表' } },
        { path: 'categories', name: 'categories', component: () => import('@/views/CategoriesView.vue'), meta: { title: '资源分类' } },
        { path: 'updates', name: 'updates', component: () => import('@/views/UpdatesView.vue'), meta: { title: '系统更新' } },
        { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue'), meta: { title: '系统设置' } },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
    ],
  });

  router.beforeEach((to) => {
    const auth = useAuthStore();
    if (to.meta.auth && !auth.token) return { name: 'login', query: { redirect: to.fullPath } };
    if (to.meta.guest && auth.token) return { name: 'dashboard' };
  });

  return router;
}
